import Joi from "joi";

export const ValidadeProductionOrderItem = (product) => {
  const schema = Joi.object({
    idOrdemProducao: Joi.string().required().messages({
      "string.empty": "(Ordem de produção) deve ser salva!",
      "any.required": "(Ordem de produção) deve ser salva!",
    }),
    idProduto: Joi.alternatives().conditional('tipoItem', {
      is: Joi.valid('simples', 'mt2'),
      then: Joi.string().required().messages({
        "string.empty": "(Produto) deve ser informado!",
        "any.required": "(Produto) deve ser informado!",
      }),
      otherwise: Joi.string().allow(null, ''),
    }),
    idServico: Joi.alternatives().conditional('tipoItem', {
      is: 'servico',
      then: Joi.string().required().messages({
        "string.empty": "(Serviço) deve ser informado!",
        "any.required": "(Serviço) deve ser informado!",
      }),
      otherwise: Joi.string().allow(null, ''),
    }),
  })

  const { error } = schema.validate(product, {
    allowUnknown: true,
  })

  if (error?.details[0]?.message || error?.details[0]?.path[0]) {
    return {
      message: error?.details[0]?.message,
      keyError: error?.details[0]?.path[0]
    }
  }
}
